import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './components/auth/Login';
import MainPage from './components/MainPage';
import ProtectedRoute from './components/ProtectedRoute';
import AddBooking from './components/AddBooking';
import Schedule from './components/Schedule';
import AdminPage from './components/AdminPage';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute component={MainPage} />} />
          <Route path="/add-booking" element={<ProtectedRoute component={AddBooking} />} />
          <Route path="/schedule" element={<ProtectedRoute component={Schedule} />} />
          <Route path="/admin" element={<ProtectedRoute component={AdminPage} />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;